import createApiService from "@lib/create-api-service";
import { MAX_TRIES } from "@lib/street-autocomplete/constants";
import { getToken } from "@lib/street-autocomplete/services/getToken";
import { removeTokenCookie } from "@lib/street-autocomplete/services/updateCookie";
import { ADDRESS_SEARCH } from "@utils/constants";
import { reportError } from "@utils/errorReporting";

import validateAddressDetailsResponse from "../models/addressDetails";
import type { TAddressDetails } from "../types";
import mapAddressDetailsResponse from "../utils/mapAddressDetailsResponse";

type TAddressDetailsParams = {
  id: string;
  defaultLocale: string;
  errCallback?: () => void;
  count?: number;
};

const getAddressDetails = createApiService({
  method: "GET",
  baseURL: ADDRESS_SEARCH.LOOKUP_SEARCH_BASE_URL,
  url: "/lookup",
  isExternalApi: true,
});

const loadAddressDetails = async ({
  id,
  defaultLocale,
  errCallback,
  count = 0,
}: TAddressDetailsParams): Promise<TAddressDetails | null> => {
  try {
    const token = await getToken(defaultLocale);
    const response = await getAddressDetails({
      params: {
        id,
        lang: "en-US",
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention
      headers: { Authorization: `Bearer ${token}` } as any,
    });
    if (!response.isSuccess) {
      if (response.statusCode === 401 && count < MAX_TRIES) {
        removeTokenCookie();
        const incrementedCount = count + 1;
        return await loadAddressDetails({ id, defaultLocale, errCallback, count: incrementedCount });
      }
      throw new Error(response.error?.message);
    }

    const validResponse = validateAddressDetailsResponse(response.data);

    return mapAddressDetailsResponse(validResponse);
  } catch (err) {
    console.log(err);
    reportError(err, { module: "address-search" });
    errCallback?.();
    return null;
  }
};
export default loadAddressDetails;
